import { render, staticRenderFns } from "./CuRadioGroup.vue?vue&type=template&id=c382d8c2"
import script from "./CuRadioGroup.vue?vue&type=script&lang=js"
export * from "./CuRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports